import React from 'react';
import { StyleSheet, View } from 'react-native';

import { LabelText, theme } from '@sg/garnish';

// ─────────────────────────────────────────────────────────────────────────────

export const MenuCategoryBadge = (props: Props) => {
  const { children } = props;

  return (
    <View style={styles.container}>
      <LabelText sizeMatch={['10']}>{children}</LabelText>
    </View>
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    backgroundColor: theme.colors.LIME,
    borderRadius: theme.radius.medium,
    paddingVertical: 2,
    paddingHorizontal: theme.spacing['2'],
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = {
  children: string;
};
